import { Timestamp, toInt, toTimestamp } from '@principle-theorem/shared';
import { get } from 'lodash';
import * as moment from 'moment-timezone';
import { CLOUD_STORAGE_CREATED_AT_METADATA_KEY } from '../../d4w/destination/entities/patient-files';
import { ICopiedFileInfo } from '../../storage/storage.generic';

export function getBucketFileCreatedAt(
  file: Pick<ICopiedFileInfo, 'metadata'>
): Timestamp | undefined {
  const createdAtUnix = String(
    get(
      file.metadata,
      `metadata.${CLOUD_STORAGE_CREATED_AT_METADATA_KEY}`,
      get(file.metadata, CLOUD_STORAGE_CREATED_AT_METADATA_KEY, '')
    )
  );

  try {
    return toTimestamp(moment.unix(toInt(createdAtUnix)));
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Error parsing createdAt date ${createdAtUnix}`);
  }
}
